// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".scroll[data-v-24dbee3c] {\n  overflow: auto;\n  max-height: 750px;\n}\ntd[data-v-24dbee3c] { /* or whatever specific values you prefer */\n}\n[dir] td[data-v-24dbee3c] {\n  border-bottom: 1px solid #ccc !important;\n}\n", ""]);
// Exports
module.exports = exports;
